import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { InputFormik } from "@/components/ui/input-formik";
import { toast } from "@/components/ui/use-toast";
import AcessoService from "@/services/AcessoService";
import { useFormik } from "formik";
import { useState, useEffect } from "react";
import * as Yup from 'yup';

interface AutenticarPorCodigoStepEmailValidoProps {
    setStep: (step: 'Inicial' | 'EmailValido' | 'EmailInvalido') => void;
    handleVerificacao: (codigo: string, emailValido: boolean, cpf: string, email?: string) => void;
    destino: string;
    cpf: string;
}

export function AutenticarPorCodigoStepEmailValido({ setStep, cpf, handleVerificacao, destino }: AutenticarPorCodigoStepEmailValidoProps) {
    const [countdown, setCountdown] = useState(60);
    const [isCounting, setIsCounting] = useState(true);

    const formik = useFormik({
        initialValues: {
            codigoVerificacao: '',
        },
        validationSchema: Yup.object({
            codigoVerificacao: Yup.string().required('Obrigatório')
        }),
        onSubmit: async (values) => {
            try {
                await handleVerificacao(values.codigoVerificacao, true, cpf);
            } catch (error) {
                toast({
                    variant: 'destructive',
                    description: 'CPF Inválido',
                    duration: 3000
                });
            }
        }
    })

    useEffect(() => {
        if (!isCounting) return;

        const interval = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    setIsCounting(false);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [isCounting]);

    async function verificarRecaptcha() {
        try {
            const grecaptcha = (window as any).grecaptcha;
            const token = await grecaptcha.execute('6LdL-BcsAAAAAMp9u6pw0p90qR518KgqzfiSihU3', { action: 'submit' })!;
            return token;
        } catch (error: any) {
            toast({
                variant: 'destructive',
                description: error,
                duration: 4000
            });
            return null;
        }
    }


    async function handleReenviarCodigo() {
        try {
            const recaptchaToken = await verificarRecaptcha();
            if (!recaptchaToken) {
                toast({
                    variant: 'destructive',
                    description: 'Erro ao verificar recaptcha',
                    duration: 3000
                });
                return;
            }

            await AcessoService.obterCodigoVerificacaoCliente(cpf, recaptchaToken);
            toast({
                variant: 'success',
                description: 'Código reenviado com sucesso',
                duration: 3000
            });
            setCountdown(60);
            setIsCounting(true);
        } catch (error: any) {
            toast({
                variant: 'destructive',
                description: error,
                duration: 3000
            });
        }
    }

    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <Card className="mx-auto max-w-sm p-5 mb-5">
                    <h1 className="text-center text-primary font-semibold">
                        Insira o Código de Verificação enviado para o seu email - {destino}
                    </h1>
                    <InputFormik
                        disabled={formik.isSubmitting}
                        type="text"
                        id="codigoVerificacao"
                        className="text-center text-primary text-2xl mt-4"
                        required
                        formik={formik}
                        name='codigoVerificacao'
                        autoComplete="off"
                        maxLength={6}
                    />
                    <div className="flex justify-center mt-4">
                        <Button
                            type="button"
                            variant="outline"
                            disabled={countdown > 0}
                            onClick={handleReenviarCodigo}
                            className="w-full">
                            {countdown > 0 ? `Reenviar Código (${countdown}s)` : 'Reenviar Código'}
                        </Button>
                    </div>
                    <div className="flex justify-center gap-2 mt-5">
                        <Button
                            disabled={!formik.isValid || formik.isSubmitting}
                            type="submit"
                            variant="foreground"
                            className="mt-2">
                            {
                                formik.isSubmitting ? <span>Verificando...</span> : <span>Verificar</span>
                            }
                        </Button>
                    </div>
                </Card>
                <div className="flex justify-center gap-2 mt-5 mb-5">
                    <Button onClick={() => setStep('Inicial')}>
                        Cancelar
                    </Button>
                </div>
            </form>
        </>
    )
}